"use strict";

var _defineProperty = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _createForOfIteratorHelper = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Survey;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _SurveyQuestion = require("../SurveyQuestion");
var _SurveyQuestion2 = _interopRequireDefault(_SurveyQuestion);
var _Button = require("@mui/material/Button");
var _Button2 = _interopRequireDefault(_Button);
var _KeyboardArrowLeft = require("@mui/icons-material/KeyboardArrowLeft");
var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);
var _KeyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);
var _Check = require("@mui/icons-material/Check");
var _Check2 = _interopRequireDefault(_Check);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _surveyjsExpressionEval = require("surveyjs-expression-eval");
var _surveyjsExpressionEval2 = _interopRequireDefault(_surveyjsExpressionEval);
var _validators = require("../../hooks/use-question-answer/validators.js");
var _validators2 = _interopRequireDefault(_validators);
var _QuestionContext = require("../QuestionContext");
var _QuestionContext2 = _interopRequireDefault(_QuestionContext);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var scrollToElement = function scrollToElement(idOrElm) {
  var elm = typeof idOrElm === "string" ? document.getElementById(idOrElm) : idOrElm;
  if (elm) {
    elm.scrollIntoView({
      block: "start",
      behavior: "smooth"
    });
  }
};
var SurveyActions = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n"])), function (_ref) {
  var onlyOnePage = _ref.onlyOnePage;
  return !onlyOnePage ? "space-between" : "space-around";
});
function Survey(_ref2) {
  var form = _ref2.form,
    onFileUpload = _ref2.onFileUpload,
    noActions = _ref2.noActions,
    completeText = _ref2.completeText,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "paper" : _ref2$variant,
    _ref2$onFinish = _ref2.onFinish,
    onFinish = _ref2$onFinish === void 0 ? function () {
      return null;
    } : _ref2$onFinish,
    autocompleteRequest = _ref2.autocompleteRequest,
    _ref2$onQuestionChang = _ref2.onQuestionChange,
    onQuestionChange = _ref2$onQuestionChang === void 0 ? function () {
      return null;
    } : _ref2$onQuestionChang,
    _ref2$defaultAnswers = _ref2.defaultAnswers,
    defaultAnswers = _ref2$defaultAnswers === void 0 ? {} : _ref2$defaultAnswers;
  var _ref3 = (0, _react.useState)(0),
    _ref4 = _slicedToArray(_ref3, 2),
    currentPage = _ref4[0],
    setCurrentPage = _ref4[1];
  var _ref5 = (0, _react.useState)(defaultAnswers),
    _ref6 = _slicedToArray(_ref5, 2),
    answerMap = _ref6[0],
    setAnswerMap = _ref6[1];
  var _ref7 = (0, _react.useState)([]),
    _ref8 = _slicedToArray(_ref7, 2),
    failingQuestions = _ref8[0],
    changeFailingQuestions = _ref8[1];
  var surveyDiv = (0, _react.useRef)(null);
  var questions = form.questions || form.pages[currentPage].elements;
  var visibleQuestions = questions.filter(function (q) {
    return q.visibleIf === undefined ? true : (0, _surveyjsExpressionEval2.default)(q.visibleIf, answerMap);
  });
  var firstPage, lastPage;
  if (form.questions) {
    // single page survey
    firstPage = true;
    lastPage = true;
  } else {
    firstPage = currentPage === 0;
    lastPage = currentPage === form.pages.length - 1;
  }
  var onlyOnePage = firstPage && lastPage;
  var validatePage = function validatePage() {
    var fqs = [];
    var _iterator = _createForOfIteratorHelper(visibleQuestions),
      _step;
    try {
      var _loop = function _loop() {
          var question = _step.value;
          if (question.isRequired && answerMap[question.name] === undefined) {
            fqs.push({
              question: question,
              text: "This question is required!"
            });
            return 0; // continue
          }
          if (answerMap[question.name] !== undefined) {
            var failingValidator = (question.validators || []).find(function (v) {
              return !(0, _validators2.default)(v, answerMap[question.name], answerMap);
            });
            if (failingValidator) {
              fqs.push({
                question: question,
                text: failingValidator.text
              });
              return 0; // continue
            }
          }
        },
        _ret;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    changeFailingQuestions(fqs);
    if (fqs.length > 0) {
      return fqs[0];
    } else {
      return {};
    }
  }; // TODO complex survey validator logic

  var pageComplete = true;
  return _react2.default.createElement("div", {
    ref: surveyDiv
  }, visibleQuestions.map(function (q) {
    return _react2.default.createElement(_QuestionContext2.default.Provider, {
      key: q.name,
      value: {
        error: (failingQuestions.find(function (fq) {
          return fq.question.name === q.name;
        }) || {}).text,
        containerStyleType: variant
      }
    }, _react2.default.createElement(_SurveyQuestion2.default, {
      question: _objectSpread(_objectSpread({}, q), {}, {
        defaultAnswer: defaultAnswers[q.name]
      }),
      onFileUpload: onFileUpload,
      onChangeAnswer: function onChangeAnswer(newAnswer) {
        var newAnswerMap = _objectSpread(_objectSpread({}, answerMap), {}, _defineProperty({}, q.name, newAnswer));
        setAnswerMap(newAnswerMap);
        onQuestionChange(q.name, newAnswer, newAnswerMap);
      },
      autocompleteRequest: autocompleteRequest
    }));
  }), !noActions && _react2.default.createElement(SurveyActions, {
    onlyOnePage: onlyOnePage
  }, !onlyOnePage && _react2.default.createElement(_Button2.default, {
    disabled: firstPage,
    onClick: function onClick() {
      return setCurrentPage(currentPage - 1);
    }
  }, _react2.default.createElement(_KeyboardArrowLeft2.default, null), "Prev"), _react2.default.createElement(_Button2.default, {
    onClick: function onClick() {
      var _validatePage = validatePage(),
        failingQuestion = _validatePage.question,
        text = _validatePage.text;
      if (failingQuestion) {
        scrollToElement(failingQuestion.name);
      } else {
        onFinish(answerMap);
      }
    },
    disabled: !lastPage || !pageComplete
  }, completeText ? completeText : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_Check2.default, {
    style: {
      marginRight: 4
    }
  }), "Complete")), !onlyOnePage && _react2.default.createElement(_Button2.default, {
    onClick: function onClick() {
      var _validatePage2 = validatePage(),
        failingQuestion = _validatePage2.question,
        text = _validatePage2.text;
      if (failingQuestion) {
        scrollToElement(failingQuestion.name);
      } else {
        scrollToElement(surveyDiv.current);
        setCurrentPage(currentPage + 1);
      }
    },
    disabled: !pageComplete || lastPage
  }, "Next", _react2.default.createElement(_KeyboardArrowRight2.default, null))));
}